import { type RichText } from '@healthlabs/prismic';

export type QuestTypes = 'example' | 'available' | 'next';

export enum QuestProgress {
    Unavailable = 'unavailable',
    Active = 'active',
    Done = 'done',
    Next = 'next',
}

export interface Quest {
    id?: number;
    coins: number;
    title?: string;
    description?: string;
    fullDescription?: string | null;
    fullDescriptionRichText?: RichText | null;
    tag?: string;
    tagColor?: string;
    dateEnd?: string;
    isDone?: boolean;
    level?: number;
    questCode?: string;
}
